import React from "react";
import { useGetContractProductImages } from "@/services/Contracts";
import DetailRow from "@/components/molecules/DrawerDetails/DetailsRow";
import ImageCarousel from "@/components/molecules/ImageCarousel";
import { CompanySpecificProduct } from "@/types";
import { useTranslation } from "react-i18next";

interface ProductProps {
  defaultProductName?: string;
  product?: CompanySpecificProduct | null;
}

const OrderProductDetails: React.FC<ProductProps> = ({ defaultProductName, product }) => {
  const { t } = useTranslation();
  const { data: productImages, isLoading: isPendingImages } = useGetContractProductImages(
    product?.id as number,
    product?.images as string[],
    {
      enabled: !!product?.id || (product?.images && product?.images.length > 0),
    }
  );
  const { data: productAttachments, isLoading: isPendingAttachments } = useGetContractProductImages(
    product?.id as number,
    product?.attachments as string[],
    {
      enabled: !!product?.id || (product?.attachments && product?.attachments.length > 0),
    }
  );

  const productLabel = product?.companySpecificProductName || defaultProductName;

  return (
    <React.Fragment>
      <DetailRow label="product:product" value={productLabel ?? ""} isLoading={false} />
      <DetailRow
        label={"common:images"}
        value={
          <>
            {productImages && productImages.length === 0 && !isPendingImages && t("common:noImagesFound")}
            <ImageCarousel images={productImages} isLoading={isPendingImages} height={150} />
          </>
        }
        isLoading={isPendingImages}
      />
      <DetailRow
        label={"common:attachments"}
        value={
          <>
            {productImages && productImages.length === 0 && !isPendingImages && t("common:noAttachmentsFound")}
            <ImageCarousel images={productAttachments} isLoading={isPendingAttachments} />
          </>
        }
        isLoading={isPendingImages}
      />
    </React.Fragment>
  );
};
export default OrderProductDetails;
